import { html } from 'lit';
const Font =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M1 18.161c0 .468.387.804.916.804.457 0 .722-.214.895-.702l1.292-3.642h5.809l1.302 3.642c.173.488.437.702.895.702.53 0 .916-.336.916-.804 0-.132-.03-.285-.112-.509L8.183 4.875c-.225-.6-.59-.875-1.15-.875-.6 0-.977.285-1.2.885L1.111 17.652c-.081.224-.112.377-.112.509m8.393-5.097H4.632l2.35-6.694h.06zm4.26 2.767c0 1.903 1.414 3.174 3.52 3.174 1.425 0 2.778-.793 3.408-2.004h.04v1.11c0 .528.347.894.845.894.489 0 .834-.366.834-.895v-6.602c0-2.106-1.566-3.449-4.048-3.449-1.72 0-3.266.763-3.866 1.923a1.53 1.53 0 0 0-.214.732c0 .478.326.794.784.794.335 0 .57-.132.732-.427.59-1.048 1.373-1.465 2.523-1.465 1.465 0 2.32.773 2.32 2.065v.885l-3.042.173c-2.442.142-3.836 1.281-3.836 3.092m6.877-1.027c0 1.526-1.292 2.696-2.96 2.696-1.272 0-2.116-.662-2.116-1.669 0-.997.814-1.627 2.238-1.719l2.838-.173z" clip-rule="evenodd"/>
  </svg>
`;
export default Font;
